// extracted by css-extract-rspack-plugin
export default {"menuList":"menuList-FHxnMl","deleteItem":"deleteItem-suYAlg"};